import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Typography, Divider, Paper } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { toast } from "react-toastify";

function RoundBooking() {
  const location = useLocation();
  const { traceId, onwardFlight, returnFlight } = location.state || {};
  const jwtToken = localStorage.getItem("token");

  const [onwardFareResponse, setOnwardFareResponse] = useState(null);
  const [returnFareResponse, setReturnFareResponse] = useState(null);

  console.log("onwardFareResponse:", onwardFareResponse);
  console.log("returnFareResponse:", returnFareResponse);
  
  const [onwardSSR, setOnwardSSR] = useState(null);
  const [returnSSR, setReturnSSR] = useState(null);

  const fetchSSR = async () => {
    const headers = {
      Authorization: `Bearer ${jwtToken}`,
    };

    try {
      const onwardIsLCC = onwardFareResponse?.data?.Response?.Results?.IsLCC || true;
      const returnIsLCC = returnFareResponse?.data?.Response?.Results?.IsLCC || true;

      console.log("onwardFareResponse:", onwardFareResponse);
      console.log("returnFareResponse:", returnFareResponse);

      console.log("onwardIsLCC:", onwardIsLCC);
      console.log("returnIsLCC:", returnIsLCC);

      if (onwardIsLCC) {
        const ssrRes = await axios.post(
          "https://api.ipaisa.co.in/myapp/flight/ssr",
          {
            traceId,
            resultIndex: onwardFlight?.ResultIndex,
          },
          { headers }
        );
        setOnwardSSR(ssrRes);
        console.log("onwardSSR:", ssrRes.data);
        toast.success("onwardSSR fetched");
      }

      if (returnIsLCC) {
        const ssrRes = await axios.post(
          "https://api.ipaisa.co.in/myapp/flight/ssr",
          {
            traceId,
            resultIndex: returnFlight?.ResultIndex,
          },
          { headers }
        );
        setReturnSSR(ssrRes);
        console.log("returnSSR:", ssrRes.data);
        toast.success("returnSSR fetched");
      }
    } catch (err) {
      console.error("SSR API Error:", err);
      toast.error("SSR API Error");
    }
  };

  useEffect(() => {
    const headers = {
      Authorization: `Bearer ${jwtToken}`,
    };

    const fetchFareQuotes = async () => {
      try {
        const [onwardRes, returnRes] = await Promise.all([
          axios.post(
            "https://api.ipaisa.co.in/myapp/flight/farequote",
            {
              traceId,
              resultIndex: onwardFlight?.ResultIndex,
            },
            { headers }
          ),
          axios.post(
            "https://api.ipaisa.co.in/myapp/flight/farequote",
            {
              traceId,
              resultIndex: returnFlight?.ResultIndex,
            },
            { headers }
          ),
        ]);
        setOnwardFareResponse(onwardRes);
        setReturnFareResponse(returnRes);
        console.log("onwardFareQuote:", onwardRes.data);
        console.log("returnFareQuote:", returnRes.data);
        fetchSSR();
      } catch (error) {
        console.error("FareQuote API Error:", error);
      }
    };

    fetchFareQuotes();
  }, [traceId, onwardFlight, returnFlight, jwtToken]);

  //   useEffect(() => {
  //     const fetchSSR = async () => {
  //       const headers = {
  //         Authorization: `Bearer ${jwtToken}`,
  //       };

  //       try {
  //         const onwardIsLCC = onwardFareResponse?.data?.Response?.Results?.IsLCC;
  //         const returnIsLCC = returnFareResponse?.data?.Response?.Results?.IsLCC;

  //         console.log("onwardIsLCC:", onwardIsLCC);
  //         console.log("returnIsLCC:", returnIsLCC);

  //         if (onwardIsLCC) {
  //           const ssrRes = await axios.post(
  //             "https://api.ipaisa.co.in/myapp/flight/ssr",
  //             {
  //               traceId,
  //               resultIndex: onwardFlight?.ResultIndex,
  //             },
  //             { headers }
  //           );
  //           setOnwardSSR(ssrRes);
  //           console.log("onwardSSR:", ssrRes.data);
  //         }

  //         if (returnIsLCC) {
  //           const ssrRes = await axios.post(
  //             "https://api.ipaisa.co.in/myapp/flight/ssr",
  //             {
  //               traceId,
  //               resultIndex: returnFlight?.ResultIndex,
  //             },
  //             { headers }
  //           );
  //           setReturnSSR(ssrRes);
  //           console.log("returnSSR:", ssrRes.data);
  //         }
  //       } catch (err) {
  //         console.error("SSR API Error:", err);
  //       }
  //     };

  //     // Ensure SSR is triggered only when both fare responses are received
  //     if (
  //       onwardFareResponse?.data?.Response?.Results &&
  //       returnFareResponse?.data?.Response?.Results
  //     ) {
  //       fetchSSR();
  //     }
  //   }, [
  //     onwardFareResponse,
  //     returnFareResponse,
  //     traceId,
  //     onwardFlight,
  //     returnFlight,
  //     jwtToken,
  //   ]);

  const formatTime = (datetime) =>
    new Date(datetime).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

  const formatDate = (datetime) => new Date(datetime).toLocaleDateString();

  const renderFlightSegments = (flight) =>
    flight?.Segments?.[0]?.map((segment, index) => (
      <Box key={index} sx={{ mb: 2 }}>
        <Typography variant="subtitle1" fontWeight="bold">
          {segment.Airline.AirlineName} ({segment.Airline.AirlineCode}
          {segment.Airline.FlightNumber})
        </Typography>
        <Typography>
          {segment.Origin.Airport.CityName} (
          {segment.Origin.Airport.AirportCode}) →{" "}
          {segment.Destination.Airport.CityName} (
          {segment.Destination.Airport.AirportCode})
        </Typography>
        <Typography>
          Departure: {formatDate(segment.Origin.DepTime)}{" "}
          {formatTime(segment.Origin.DepTime)}
        </Typography>
        <Typography>
          Arrival: {formatDate(segment.Destination.ArrTime)}{" "}
          {formatTime(segment.Destination.ArrTime)}
        </Typography>
        <Typography>Duration: {segment.Duration} mins</Typography>
        <Typography>
          Baggage: {segment.Baggage} | Cabin: {segment.CabinBaggage}
        </Typography>
        <Typography>Class: {segment.SupplierFareClass}</Typography>
        {index < flight.Segments[0].length - 1 && <Divider sx={{ my: 1 }} />}
      </Box>
    ));

  return (
    <Box px={3} sx={{ marginTop: "8%" }}>
      <Typography gutterBottom>Service &gt; Flight Booking</Typography>
      <Typography gutterBottom>Round Trip Booking</Typography>

      <Grid container spacing={2}>
        <Grid item md={6}>
          {onwardFlight && (
            <Paper sx={{ p: 2, borderRadius: 3 }}>
              <Typography variant="h6" gutterBottom>
                Onward Flight - ₹{" "}
                {onwardFlight?.FareBreakdown?.[0]?.RootFareTotal}
              </Typography>
              {renderFlightSegments(onwardFlight)}
            </Paper>
          )}
        </Grid>
        <Grid item md={6}>
          {returnFlight && (
            <Paper sx={{ p: 2, borderRadius: 3 }}>
              <Typography variant="h6" gutterBottom>
                Return Flight - ₹{" "}
                {returnFlight?.FareBreakdown?.[0]?.RootFareTotal}
              </Typography>
              {renderFlightSegments(returnFlight)}
            </Paper>
          )}
        </Grid>
      </Grid>

      {onwardFlight && returnFlight && (
        <Typography mt={2} mb={2} variant="h6" fontWeight="bold">
          Total Price: ₹{" "}
          {(
            Number(onwardFlight?.FareBreakdown?.[0]?.RootFareTotal || 0) +
            Number(returnFlight?.FareBreakdown?.[0]?.RootFareTotal || 0)
          ).toLocaleString()}
        </Typography>
      )}
    </Box>
  );
}

export default RoundBooking;
